import { defineStore } from "pinia";
import type { MenuTreeTypes } from "@/common/types/MenuTypes.ts";

export const userSidebarStore = defineStore("sidebar", {
  state: () => ({
    routeYn: false,
    render: false,
    sidebarDrawer: null as null | boolean,
    sidebarMenu: [] as MenuTreeTypes[],
    breadcrumbs: [
      {
        title: "",
        disabled: false,
      },
    ],
  }),
  actions: {
    setSidebarDrawer(state: MouseEvent) {
      this.sidebarDrawer = !!state;
    },
    setBreadcrumbs(breadcrumbs: []) {
      this.breadcrumbs = breadcrumbs;
    },
    setRender(state: boolean) {
      this.render = state;
    },
    setRouteYn(state: boolean) {
      this.routeYn = state;
    },
    setSidebarMenu(sidebarMenu: MenuTreeTypes[]) {
      this.sidebarMenu = sidebarMenu;
    },
  },
  getters: {
    getRouteYn: (state) => state.routeYn,
    getSidebarMenu: (state) => state.sidebarMenu,
  },
});
